import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import { useDispatch } from 'react-redux';

import { ComponentLoader } from 'components';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import fetch from 'features/common/fetch';
import { downloadAttachment } from 'features/views/taskDetail/actions';

export const TaskAttachment = ({ item, taskId }) => {
	const dispatch = useDispatch();

	const handleClickAttachment = useCallback(
		(attachment) => () => {
			if (attachment.externalUrl) {
				window.open(attachment.externalUrl).focus();
			} else {
				dispatch(downloadAttachment(Number(taskId), attachment.id));
			}
		},
		[dispatch, taskId],
	);

	const ignoreErrorsForTaskAttachemntNotFound = useIgnoreErrorsWhen({
		fetchStorePath: `${fetch.constants.urls.taskAttachmentById}.${item.id}`,
		attributePath: ['metaData', 'parsedContent', 'status'],
		value: 404,
	});

	return (
		<Link
			sx={{
				fontSize: 16,
				fontWeight: 'bold',
				width: 'fit-content',
			}}
			key={item?.id}
			underline="none"
			onClick={handleClickAttachment(item)}
		>
			<ComponentLoader
				fetchStorePath={`${fetch.constants.urls.taskAttachmentById}.${item.id}`}
				ignoreErrors={ignoreErrorsForTaskAttachemntNotFound}
			>
				{item.attachmentName}
			</ComponentLoader>
		</Link>
	);
};

TaskAttachment.propTypes = {
	item: PropTypes.object,
	taskId: PropTypes.string,
};

export default TaskAttachment;
